import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const ProektirovanieResult = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){
        $(this.$el).find('[data-fancybox]').fancybox({
            loop: true,
        });
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="Object.keys(this.struct[this.structKey].componentData.ITEMS).length" class="section">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Состав дизайн-проекта
                </h2>
            </div>
        </div>
        <div class="result__list">
            <a v-for="item in this.struct[this.structKey].componentData.ITEMS"
                class="result__list-item"
                :key="item.ID"
                :href="item.BIG"
                data-fancybox="results"
            >
                <img class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.MEDIUM" :alt="item.NAME" :title="item.NAME">
                <div class="result__list-item-title">
                    {{item.NAME}}
                </div>
            </a>
        </div>
    </div>
</section>
    `
}